export default __webpack_public_path__ + "static/data-about-screenshot-2-a12d07c957936318f2559e632765c0aa.webp";